/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleValidationData
 */
export interface BookingIdRemarkRuleValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingIdRemarkRuleValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingIdRemarkRuleValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingIdRemarkRuleValidationData
     */
    bookingIdRemark?: ValidationMessage;
}

export function BookingIdRemarkRuleValidationDataFromJSON(json: any): BookingIdRemarkRuleValidationData {
    return BookingIdRemarkRuleValidationDataFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : ValidationMessageFromJSON(json['bookingIdRemark']),
    };
}

export function BookingIdRemarkRuleValidationDataToJSON(value?: BookingIdRemarkRuleValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'bookingIdRemark': ValidationMessageToJSON(value.bookingIdRemark),
    };
}


